module.exports = __webpack_public_path__ + "static/img/supersign-box.a3dfd13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/supersign-box.png
// module id = 1f02
// module chunks = 1